/**
 * Shared UI strings used across many components: generic actions, states
 * and error messages. English is the source of truth for all locales —
 * the other language dictionaries are type-checked against this shape.
 *
 * Values are either a plain string (may contain `{placeholders}`) or a
 * plural object like `{ one: '{count} item', other: '{count} items' }`.
 */
export const common = {
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    remove: 'Remove',
    confirm: 'Confirm',
    done: 'Done',
    send: 'Send',
    back: 'Back',
    seeAll: 'See all',
  },
  states: {
    loading: 'Loading...',
    sending: 'Sending...',
    saving: 'Saving...',
    yes: 'Yes',
    no: 'No',
  },
  // On-demand pagination footer shown by niup-infinite-scroll below long lists.
  pagination: {
    loadingMore: 'Loading more...',
    loadMore: 'Load more',
    retry: 'Try again',
    failed: 'Could not load more items.',
    progress: '{loaded} of {total}',
  },
  errors: {
    generic: 'Something went wrong. Please try again.',
    loadFailed: 'Failed to load data.',
    saveFailed: 'Failed to save changes.',
    loadUser: 'Failed to load user.',
    loadContent: 'Failed to load content.',
  },
  // Accessibility labels (aria-label / role text) reused by several controls.
  a11y: {
    avatar: 'Avatar',
    close: 'Close',
  },
  // Site footer: brand tagline, column titles and link labels.
  footer: {
    tagline: 'May all who enter alone leave connected',
    quickAccess: 'Quick access',
    homepage: 'Homepage',
    companies: 'Companies',
    people: 'People',
    permissionsGroup: 'Permissions group',
    activity: 'Activity',
    myProfile: 'My profile',
    edit: 'Edit',
    notifications: 'Notifications',
    legalArticles: 'Legal articles',
    terms: 'Terms & Conditions',
    privacy: 'Privacy policy',
    cookies: 'Cookies policy',
    contact: 'Contact',
    copyright: 'Copyright © 2026 Niup Technologies | All Rights Reserved',
  },
  // Authentication level badge card (niup-auth-level-badge).
  authLevel: {
    title: 'Authentication level',
    subtitle: 'Level {number} of 3',
    info: 'About authentication level',
    stepInitial: 'Initial',
    stepIntermediate: 'Intermediate',
    stepVerified: 'Verified',
    request: 'Request authentication',
    note: 'This section will disappear when your account is verified.',
  },
  // Floating help button menu (niup-help-button).
  helpButton: {
    ariaLabel: 'Help',
    greeting: 'Hi! How can we help you?',
    chatExpert: 'Chat with a product expert',
    learnMore: 'Learn more about Niup',
    needSupport: "I'm a customer and need support",
  },
  // Session expiry toast (niup-session-toast).
  sessionToast: {
    expired: 'Your session has expired. Redirecting to login...',
  },
  // Password field control (niup-password-field).
  passwordField: {
    hide: 'Hide password',
    show: 'Show password',
  },
};
